export default __webpack_public_path__ + "static/Mont-Light-56e2710418ebdd8889086eba82e6b93a.otf";